import { Button } from "@ui/Button";
import { Dropdown } from "@ui/Dropdown";
import { Match, Switch } from "solid-js";
import type { ArtifactOutput } from "../../ChatEventTypes.ts";

declare const pageVars: {
	appEmbedded: boolean;
};

type Props = {
	outputs: ArtifactOutput[];
};

function downloadOutputUrl(url: string) {
	if (pageVars.appEmbedded) {
		document.dispatchEvent(
			new CustomEvent("downloadasset", {
				detail: { asset_url: url },
			}),
		);
		return;
	}
	window.open(url, "_blank");
}

const DownloadButton = (props: { onClick?: () => void }) => (
	<Button
		monospaced
		variant="text"
		theme="monochrome"
		symbol="download"
		symbolRelativeSize="even-larger"
		symbolPosition="after"
		onClick={props.onClick}
	>
		download
	</Button>
);

/**
 * Toolbar download control. Shown when the artifact has `outputs` with URLs.
 * One file downloads immediately; several open {@link Dropdown} to pick a format.
 */
export const ArtifactDownload = (props: Props) => {
	const outputs = () => props.outputs;

	return (
		<Switch>
			<Match when={outputs().length > 1}>
				<Dropdown
					aria-label="Download format"
					placement="bottom end"
					triggerVariant="none"
					trigger={<DownloadButton />}
					options={outputs().map((output) => ({
						label: output.format_label,
						value: output.url,
					}))}
					onChange={(url) => downloadOutputUrl(String(url))}
				/>
			</Match>
			<Match when={outputs()[0]}>
				{(output) => (
					<DownloadButton onClick={() => downloadOutputUrl(output().url)} />
				)}
			</Match>
		</Switch>
	);
};
